<div class="row w-100 mx-0 justify-content-center mt-5 border-2">
  <div class="col-12 col-md-7 my-auto col-lg-8 py-5 px-md-5 px-4 mb-4 mb-md-auto order-md-1 order-2">
    <div class="title">
      {{ "Generate Cover Letter" | translate }}
    </div>
    <div class="description mt-2">
      {{ "Generate your Cover Letter. Get Reach to right people, New opportunities." | translate }}
    </div>
    <div class="mt-2">
      <button class="gradient-button" (click)="scrollToSteps()">
        {{ "Build Your Cover Letter" | translate }}
      </button>
      <p class="service-detail px-2 my-2" [innerHTML]="'SERVICE_DETAIL.CL_Text' | translate"></p>
    </div>
  </div>
  <img class="col-8 col-md-5 col-lg-4 text-center p-0 order-md-2 order-1" src="../../../assets/img/cover-letter.png" />
</div>

<div class="mt-5">
<app-video-tutorial
  [title]="'coverLetteer.videoTitle'"
  [buttonText]="'coverLetteer.videoButton'"
   (buttonClicked)="scrollToSteps()"
  [videoPath]="'assets/video/Cover Letter 01.mp4'"
  [videoPoster]="'assets/img/Frame 2095587743.png'"
  [features]="[
    'coverLetteer.feature1',
    'coverLetteer.feature2',
    'coverLetteer.feature3'
  ]">
</app-video-tutorial>
</div>

<div class="scan" #stepsSection>{{ "Generate Cover Letter" | translate }}</div>
<div class="my-4">
  <p-steps [model]="steps" [(activeIndex)]="activeIndex" />
</div>

<!-- Step 0: Upload CV -->
<div class="row w-100 m-0" *ngIf="activeIndex === 0" (dragover)="onDragOver($event)" (drop)="onLinkedinDrop($event)">
  <div class="w-100 col-lg-8 col-sm-7 col-12 p-0">
    <div class="upload-resume">
      <img width="15%" src="assets/img/upload linkedin.png" />
      <h3>{{ "Upload your CV in PDF" | translate }}</h3>
      <p>{{ "Drag and drop your resume as PDF or word file" | translate }}</p>
      <p>{{ "Or" | translate }}</p>
      <input type="file" id="uploadLinkedin" (change)="onLinkedinSelected($event)" accept=".pdf,.doc,.docx"
        #uploadLLinked hidden />
      <button class="button" (click)="uploadLLinked.click()">
        {{ "Select from Browser" | translate }}
      </button>
    </div>
  </div>
</div>

<!-- Step 1: Add Details -->
<div class="row w-100 m-0" *ngIf="activeIndex === 1">
  <div class="w-100 col-lg-8 col-sm-7 col-12 p-0">
    <form [formGroup]="jobDetailsForm">
      <div class="card-data">
        <h4>
          {{ "Job Details" | translate }}
          <span class="optional-text">({{ "Optional" | translate }})</span>
        </h4>

        <div class="row mb-3">
          <div class="col-12">
            <label>{{ "Target Job" | translate }}</label>
            <input type="text" formControlName="jobTitle"
              placeholder="{{ 'e.g. Senior Software Engineer' | translate }}" />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <label>{{ "Industry" | translate }}</label>
            <input type="text" formControlName="company" placeholder="{{ 'e.g. Google, Microsoft' | translate }}" />
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <label>{{ "Objective " | translate }}</label>
          </div>
          <div class="col-12">
            <textarea formControlName="jobDescription" rows="6" cols="20"
              placeholder="{{ 'Paste the job description here to tailor your cover letter...' | translate }}"></textarea>
          </div>
        </div>
      </div>

      <div class="next-container py-md-3 px-md-5 py-2 px-2 mobile-buttons">
        <button type="button" class="cl-border-button" (click)="onBack()">
          {{ "Back" | translate }}
        </button>
        <button type="button" class="gradient-button" (click)="onGenerateCoverLetter()" [disabled]="loading">
          <span>{{ "Generate Cover Letter" | translate }}</span>
        </button>
      </div>
    </form>
  </div>
</div>

<!-- Step 2: Review Cover Letter -->
<div *ngIf="activeIndex === 2">
  <div class="safe-area" *ngIf="clUrlImage">
    <div class="d-flex justify-content-center align-items-center mb-4">
      <h3 class="title">{{ "coverLetter.reviewTitle" | translate }}</h3>
    </div>

    <div class="row mx-2 mx-lg-5">
      <div class="col-12 col-md-5 col-lg-4 order-2 order-md-1">
        <ng-container>
          <div *ngIf="!isWordPurchased">
            <div class="row word" (click)="goToPayment('generate-cl')">
              <p class="col m-0 d-flex align-items-center justify-content-center">
                <img src="./assets/icon/word.png" />
                <span>{{ "coverLetter.purchaseWord" | translate }}</span>
              </p>
              <p class="price col-auto">50 LE</p>
            </div>
          </div>

          <div *ngIf="isWordPurchased">
            <div class="row pdf-purchased" (click)="onDownloadPdf()">
              <p class="col m-0 d-flex align-items-center justify-content-center">
                <img src="./assets/icon/word.png" />
                <span>{{ "coverLetter.downloadWord" | translate }}</span>
              </p>
              <p class="col-auto">
                <i class="pi pi-download"></i>
              </p>
            </div>
            <div class="purchase-status mt-2">
              <i class="pi pi-check-circle"></i>
              <span>{{ "coverLetter.wordPurchased" | translate }}</span>
            </div>
          </div>
        </ng-container>
      </div>

      <div class="col-12 col-md-7 col-lg-8 order-1 order-md-2 cv-preview-container"
        (contextmenu)="$event.preventDefault()">
        <div *ngIf="clUrlImage" class="text-center">
          <img [src]="clUrlImage" alt="Generated Cover Letter Preview" />
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Services Section -->
<section class="services-section">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-12 col-sm-6 col-md-4">
        <div class="title-card">
          <h3 class="services-main-title">
            {{ "Resume optimization checklist" | translate }}
          </h3>
          <p class="services-main-description">
            {{ "resume_checks_description" | translate }}
          </p>
        </div>
      </div>

      <app-card *ngFor="let item of services" [color]="item.color" [img]="item.img" [icon]="true" [title]="item.title"
        [description]="item.description" />
    </div>
  </div>
</section>

<app-video-tutorial [title]="'careerCoachingVideo.videoTitle'"
  [videoPath]="'../../../assets/video/Recording 2025-11-25 203710.mp4'"
  [videoPoster]="'../../../assets/img/Frame 2095587743.png'" [buttonText]="'careerCoachingVideo.videoButton'"
  [buttonLink]="'https://wa.me/+201555842727'">
</app-video-tutorial>

<section class="cv-section">
  <div class="container">
    <div class="text-center">
      <h3 class="titlle">{{ 'coverLetter.useGeneratorTitle' | translate }}</h3>
    </div>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-12 col-md-7 px-md-5">
        <ul class="custom-list">
          <li>{{ 'coverLetter.point1' | translate }}</li>
          <li>{{ 'coverLetter.point2' | translate }}</li>
          <li>{{ 'coverLetter.point3' | translate }}</li>
          <li>{{ 'coverLetter.point4' | translate }}</li>
        </ul>
      </div>
      <div class="col-12 col-md-5 mb-4 mb-md-0 text-center">
        <img class="img-fluid" src="assets/img/Frame_2095587929-removebg-preview.png" alt="CV Image" />
      </div>
    </div>
  </div>
</section>

<section class="cv-section">
  <div class="container">
    <div class="text-center">
      <h3 class="titlle">{{ 'linkedIn.title' | translate }}</h3>
    </div>
    <div class="row d-flex justify-content-center align-items-center">
      <div class="col-12 col-md-5 mb-4 mb-md-0 text-center">
        <img class="img-fluid" src="assets/img/Frame_2095587930-removebg-preview.png" alt="CV Image" />
      </div>
      <div class="col-12 col-md-7 px-md-5">
        <p class="section-text">{{ 'linkedIn.description' | translate }}</p>
        <button class="gradient-button" routerLink="/scan-linkedin"> {{ 'Scan Your Profile' | translate }}</button>
      </div>
    </div>
  </div>
</section>